var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "SOP 부가정보" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-6 col-sm-12 col-md-2 col-lg-2" },
                  [
                    _c("c-select", {
                      attrs: {
                        codeGroupCd: "HAZARD_GRADE_CD",
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "hazardGradeCd",
                        label: "위험등급",
                      },
                      model: {
                        value: _vm.sop.hazardGradeCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.sop, "hazardGradeCd", $$v)
                        },
                        expression: "sop.hazardGradeCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-6 col-sm-12 col-md-2 col-lg-2" },
                  [
                    _c("c-field", {
                      attrs: {
                        editable: _vm.editable,
                        label: "작업자",
                        name: "workerName",
                      },
                      model: {
                        value: _vm.sop.workerName,
                        callback: function ($$v) {
                          _vm.$set(_vm.sop, "workerName", $$v)
                        },
                        expression: "sop.workerName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        label: "안전보호구",
                        name: "saftyShied",
                      },
                      model: {
                        value: _vm.sop.saftyShied,
                        callback: function ($$v) {
                          _vm.$set(_vm.sop, "saftyShied", $$v)
                        },
                        expression: "sop.saftyShied",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        rows: 3,
                        label: "적용범위",
                        name: "applyRange",
                      },
                      model: {
                        value: _vm.sop.applyRange,
                        callback: function ($$v) {
                          _vm.$set(_vm.sop, "applyRange", $$v)
                        },
                        expression: "sop.applyRange",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        editable: _vm.editable,
                        rows: 3,
                        label: "목적",
                        name: "purpose",
                      },
                      model: {
                        value: _vm.sop.purpose,
                        callback: function ($$v) {
                          _vm.$set(_vm.sop, "purpose", $$v)
                        },
                        expression: "sop.purpose",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        counter: true,
                        maxlength: 200,
                        editable: _vm.editable,
                        rows: 3,
                        label: "작업시 안전주의사항",
                        name: "saftyCaution",
                      },
                      model: {
                        value: _vm.sop.saftyCaution,
                        callback: function ($$v) {
                          _vm.$set(_vm.sop, "saftyCaution", $$v)
                        },
                        expression: "sop.saftyCaution",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-4 col-lg-4 margincard-0",
              },
              [
                _c(
                  "c-table",
                  {
                    ref: "mmEquipTable",
                    attrs: {
                      title: "관련 설비",
                      tableId: "mmEquipTable",
                      columns: _vm.gridMmEquip.columns,
                      data: _vm.sop.mmEquips,
                      gridHeight: "284px",
                      selection: "multiple",
                      rowKey: "mdmSopMmCd",
                      isFullScreen: false,
                      columnSetting: false,
                      filtering: false,
                      usePaging: false,
                      isExcelDown: false,
                      hideBottom: true,
                      topBorderClass: "topcolor-blue",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "table-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _vm.editable && _vm.isOld
                              ? _c("c-btn", {
                                  attrs: { label: "LBLADD", icon: "add" },
                                  on: { btnClicked: _vm.addRowMmEquip },
                                })
                              : _vm._e(),
                            _vm.editable && _vm.isOld
                              ? _c("c-btn", {
                                  attrs: { label: "LBLREMOVE", icon: "remove" },
                                  on: { btnClicked: _vm.removeRowMmEquip },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-4 col-lg-4 margincard-0",
              },
              [
                _c(
                  "c-table",
                  {
                    ref: "mmMachineTable",
                    attrs: {
                      title: "관련 유해위험기계기구",
                      tableId: "mmMachineTable",
                      columns: _vm.gridMmMacine.columns,
                      data: _vm.sop.mmMachines,
                      gridHeight: "284px",
                      selection: "multiple",
                      rowKey: "mdmSopMmCd",
                      isFullScreen: false,
                      columnSetting: false,
                      filtering: false,
                      usePaging: false,
                      isExcelDown: false,
                      hideBottom: true,
                      topBorderClass: "topcolor-blue",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "table-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _vm.editable && _vm.isOld
                              ? _c("c-btn", {
                                  attrs: { label: "LBLADD", icon: "add" },
                                  on: { btnClicked: _vm.addRowMmMachine },
                                })
                              : _vm._e(),
                            _vm.editable && _vm.isOld
                              ? _c("c-btn", {
                                  attrs: { label: "LBLREMOVE", icon: "remove" },
                                  on: { btnClicked: _vm.removeRowMmMachine },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }